import React from "react";
import { ArrowRight, Leaf, ShieldCheck, TrendingDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FutureProofBuildingEnvelopes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="10553" id="ihr-partner-für-erdbau-außenanlagen" className="dark relative w-full overflow-hidden py-32 !text-[hsl(48,96%,53%)] !bg-[hsl(32,95%,44%)] lg:py-48 !bg-[url(https://tm-bauservices.de/wp-content/uploads/2026/03/Erstell-mir-so-ein-richtig-cooles-Baggerbild-mit-so-einem-richtigen-orangenen-Bagger.-Mit-bei-Sonnenuntergang-z.B.-richtig-geilen-Wolken.jpg)]">
      <div ref={ref} className={`container relative z-10 mx-auto px-4 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20 items-center">
          {}
          <div className="flex flex-col gap-8 !bg-[hsl(53,98%,77%)] lg:col-span-7">
            <div className="space-y-4 !text-[hsl(50,98%,64%)]">
              <div className="inline-flex items-center gap-2 rounded-sm border border-primary/30 bg-primary/10 px-4 py-1.5 text-xs font-mono font-bold uppercase tracking-wider text-primary w-fit">
                <ShieldCheck className="h-4 w-4" />
                
              </div>
              <h1 className="font-sans text-5xl font-extrabold tracking-tighter leading-[0.9] uppercase !text-[hsl(0,0%,0%)] sm:text-6xl lg:text-8xl">HOCH&amp;TIEFBAU PARTNER.</h1>
              <p className="max-w-2xl leading-relaxed !font-bold !text-[hsl(0,0%,0%)] !text-2xl">Ihr Spezialist für Tiefbau, Erdarbeiten und Außenanlagen. Wir realisieren Ihre Bauvorhaben mit höchster Präzision, modernstem Maschinenpark und absoluter Termintreue.</p>
            </div>

            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm h-14 px-8 text-lg font-bold shadow-[0_0_25px_rgba(249,115,22,0.4)] animate-pulse hover:animate-none transition-all uppercase">
                <Link to="/ContactPage">
                  Projekt anfragen <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-sm border-white/20 bg-white/5 hover:bg-white/10 text-foreground backdrop-blur-sm font-bold uppercase">
                <Link to="/ServicesPage">Unsere Leistungen</Link>
              </Button>
            </div>

            
          </div>

          {}
          <div className="lg:col-span-5 relative h-[500px] lg:h-[700px] w-full">
            {}
            <div className="absolute inset-0 overflow-hidden rounded-sm border border-white/10 shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/modern_facade_architecture.png" alt="Baggerarbeiten und Tiefbau Baustelle" className="h-full w-full object-cover object-center" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
            </div>

            {}
            

            {}
            
          </div>
        </div>
      </div>
    </section>;
}